<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">

    <section class="border border-gray-800 p-3">
        <div class="flex justify-between">
            <h4 class="text-white text-sm font-bold uppercase mb-3">{{ modalType }} {{ featureName }} feature</h4>
            <button type="button" class="close" @click.prevent="closeModal">
              <span>&times;</span>
            </button>
        </div>
        <div class="errormessage-wraper">
            <span v-if="$page.props.errors" v-for="err in Object.values($page.props.errors)" class="errormessage font-bold">{{ err }}</span>
        </div>
    </section>

    <slot name="languages"></slot>

    <slot name="feature-form"></slot>

    <section class="border border-gray-800 p-3">
        <div class="block text-center">
            <slot name="buttons"></slot>
        </div>
    </section>

    </div>
  </div>
</div>
</template>

<script>

export default {
    props: [
        'showModal',
        'closeModal',
        'modalType',
        'featureName',
    ]
}
</script>
